import {
  RequestScheduleType,
  ScheduleRecurrencePayload,
} from '../../../../common/models/request-schedule.model';
import {
  RecurrenceFormValue,
  RecurrenceTranslateFn,
  getNthWeekdayInMonth,
  prepareRecurrencePayload,
} from '../../../../common/utils/recurrence.utils';

export type ScheduleTranslateFn = RecurrenceTranslateFn;

/**
 * Legacy boolean "repeat on" options used when schedule_workflow_all_type is off.
 * Prefer buildMonthlyRepeatOnOptions / buildYearlyRepeatOnOptions from recurrence.utils
 * for the recurrence payload contract.
 */
export function buildLegacyMonthlyRepeatOnOptions(
  startDate: Date,
  translate: ScheduleTranslateFn
): {
  label: string;
  value: boolean;
}[] {
  const dayOfMonth = startDate.getDate();
  const { ordinalKey, dayKey } = getNthWeekdayInMonth(startDate);

  return [
    {
      label: translate('schedule_workflow_repeat_on_monthly_day_option', {
        day: dayOfMonth,
      }),
      value: true,
    },
    {
      label: translate('schedule_workflow_repeat_on_monthly_weekday_option', {
        ordinal: translate(`schedule_workflow_ordinal_${ordinalKey}_label`),
        dayName: translate(`schedule_workflow_week_day_${dayKey}_label`),
      }),
      value: false,
    },
  ];
}

/**
 * Legacy boolean "repeat on" options used when schedule_workflow_all_type is off.
 */
export function buildLegacyYearlyRepeatOnOptions(
  startDate: Date,
  translate: ScheduleTranslateFn
): {
  label: string;
  value: boolean;
}[] {
  const dayOfMonth = startDate.getDate();
  const { ordinalKey, dayKey, monthKey } = getNthWeekdayInMonth(startDate);
  const monthName = translate(`schedule_workflow_month_${monthKey}_label`);

  return [
    {
      label: translate('schedule_workflow_repeat_on_yearly_day_option', {
        day: dayOfMonth,
        month: monthName,
      }),
      value: true,
    },
    {
      label: translate('schedule_workflow_repeat_on_yearly_weekday_option', {
        ordinal: translate(`schedule_workflow_ordinal_${ordinalKey}_label`),
        dayName: translate(`schedule_workflow_week_day_${dayKey}_label`),
        month: monthName,
      }),
      value: false,
    },
  ];
}

export function prepareScheduleRecurrencePayload(
  type: RequestScheduleType,
  recurrence: Omit<RecurrenceFormValue, 'type'>,
  startDate?: Date
): ScheduleRecurrencePayload {
  return prepareRecurrencePayload({ ...recurrence, type }, startDate);
}
